exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userSearch{width:100%;text-align:center}.userSearch .userInputRowOne input{font-size:16px;display:inline-block;width:20%;margin-right:1rem}.userSearch .userInputRowTwo{margin-top:10px}.userSearch .userInputRowTwo input{font-size:16px;display:inline-block;width:20%;margin-right:1rem}.userSearch .buttonPrimary{margin-top:-.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/user_search.scss
// module id = 835
// module chunks = 0